import { AnswerDTO } from './AnswerDTO'
import { BookingSlotDTO } from './BookingSlotDTO'
import { ContactDetailsDTO } from './ContactDetailsDTO'

export class BookingRequestDTO {

    constructor(
        public id: string,
        public bookingSlot: BookingSlotDTO,
        public areaId: string,
        public contact: ContactDetailsDTO,
        public partySize: number,
        public notes: string | null,
        public agreedToMarketing: boolean,
        public agreedToTerms: boolean,
        public reasonId: string | null,
        public eventId: string | null,
        public basketItems: {
            productId: string
            skuId: string
            quantity: number
            modifierSkuIds?: string[]
            menuItemId?: string
        }[] | null,
        public answers: AnswerDTO[],
        public depositPaymentIntentId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
        public utmSource: string | null,
        public utmMedium: string | null,
        public utmCampaign: string | null,
        public durationMinutes: number | null = null,
        public additionalBookings: AdditionalBookingRequestDTO[] = [],
        public agreedToMerchantPrivacy: boolean | null = null
    ) { }
}

export interface AdditionalBookingRequestDTO {
    id: string
    bookingSlot: BookingSlotDTO
    areaId: string
    reasonId: string
    durationMinutes: number
    basketItems: NonNullable<BookingRequestDTO['basketItems']>
    answers: AnswerDTO[]
}
